import * as C from '../common/constants';
import * as ROUTES from '../common/routes';
import React, { useEffect, useState } from 'react';
import Marker from './Marker';
import clsx from 'clsx';
import ImageStory from './ImageStory';
import { getText, getPath } from '../common/utils/helpers';
import { COLORS, FONTS, FONT_WEIGHT } from '../common/theme';
import {
  GoogleMap,
  useJsApiLoader,
  useLoadScript,
  OverlayView,
  // Marker,
  InfoWindow,
  GroundOverlay,
  Rectangle,
} from '@react-google-maps/api';
import { useSelector, useDispatch } from 'react-redux';
import { fetchData } from '../common/app/actions';
import CircularProgress from '@material-ui/core/CircularProgress';
import {
  StyleRules,
  Theme,
  createStyles,
  makeStyles,
} from '@material-ui/core/styles';

const useStyles = makeStyles(
  (theme: Theme): StyleRules =>
    createStyles({
      containerStyle: {
        position: 'relative',
        width: '100%',
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        // maxWidth: `${C.MAX_WIDTH}px`,
        // padding: '24px 50px',
        // boxSizing: 'border-box',
      },
      wrapperStyle: {
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        // justifyContent: 'center',
        width: '100%',
        height: '100%',
        maxHeight: `${C.MAX_WIDTH}px`,
      },
      centerContainerStyle: {
        position: 'absolute',
        width: '100%',
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '30vh',
      },
      mapDataLoadingStyle: {
        position: 'absolute',
        width: '100%',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'rgba(0,0,0,0.5)',
        color: COLORS.white,
      },
      mapLoadingTextStyle: {
        color: COLORS.white,
        fontSize: '14px',
        fontFamily: FONTS.roboto,
        marginTop: '6px',
        // fontWeight: FONT_WEIGHT.bold,
      },
      hiddenStyle: {
        display: 'none',
      },
      noteStyle: {
        position: 'absolute',
        top: '100%',
        left: 0,
        // fontWeight: FONT_WEIGHT.bold,
        color: COLORS.appBrown,
        fontSize: '12px',
        fontFamily: FONTS.roboto,
        marginTop: '4px',
      },
    })
);

const containerStyle = {
  width: '100%',
  height: `${C.MAX_WIDTH}px`,
};

const mapCenter = {
  lat: 56.9714549,
  lng: 24.0591238,
};

const styles = [
  // {
  //   featureType: 'poi.business',
  //   stylers: [{ visibility: 'off' }],
  // },
  {
    featureType: 'administrative',
    elementType: 'all',
    stylers: [{ visibility: 'off' }],
  },
  {
    featureType: 'poi',
    elementType: 'all',
    stylers: [
      {
        visibility: 'off',
      },
    ],
  },
];

const AlbumMap = (): JSX.Element => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const lng = useSelector((state) => state.app.lng);
  const homeData = useSelector((state) => state.app.homeData);
  const mapData = useSelector((state) => state.app.mapData);
  const allAlbumData = useSelector((state) => state.app.allAlbumData);

  const [imageData, setImageData] = useState(null);

  const { isLoaded, loadError } = useLoadScript({
    id: 'google-map-script',
    googleMapsApiKey: 'AIzaSyDvC3FcVPOX5tI_PBgDHE9QEQx4bdM4up8',
    language: 'lv',
    region: 'lv',
    // version: 'beta',
    // ...otherOptions
  });

  // const getPeriodBtnIds = () => {
  //   return homeData.images.map((image) => {
  //     const correctPeriod = image.name.replace('btn_', '').replace('_', '-');
  //     return correctPeriod;
  //   });
  // };

  useEffect(() => {
    dispatch(fetchData(C.MAP_DATA, { map: true }));
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    // const fetchedPeriods = Object.keys(periodData)?.length;
    // if (homeData && fetchedPeriods <= 9) {
    //   const periodBtnIds = getPeriodBtnIds();

    //   console.log('>>>>', fetchedPeriods, periodBtnIds.length);

    //   if (fetchedPeriods !== periodBtnIds.length) {
    //     periodBtnIds.forEach((period) => {
    //       const isPeriodFetched = periodData[period];

    //       console.log('>>>>22', isPeriodFetched);

    //       if (!isPeriodFetched) {
    //         dispatch(fetchData(C.PERIOD_DATA, { period }));
    //       }
    //     });
    //   }
    // }
    if (homeData && !allAlbumData) {
      dispatch(fetchData(C.ALL_ALBUM_DATA, { all: true }));
    }
  }, [homeData]); // eslint-disable-line react-hooks/exhaustive-deps

  if (!mapData) {
    return (
      <div className={classes.centerContainerStyle}>
        <CircularProgress />
      </div>
    );
  }

  // const [map, setMap] = React.useState(null);

  // const onLoad = React.useCallback(function callback(map) {
  //   const bounds = new (window as any).google.maps.LatLngBounds();
  //   map.fitBounds(bounds);
  //   setMap(map);
  // }, []);

  // const onUnmount = React.useCallback(function callback(map) {
  //   setMap(null);
  // }, []);

  // const goHome = (event: React.SyntheticEvent) => {
  //   event.stopPropagation();
  //   event.preventDefault();

  //   history.push(ROUTES.ROOT);
  // };

  // const [map, setMap] = React.useState(null);

  // const onLoad = React.useCallback((map) => {
  //   // const bounds = new (window as any).google.maps.LatLngBounds();
  //   // map.fitBounds(bounds);
  //   // setMap(map);

  //   // map.setHeading(90);
  //   // map.setOptions({ styles });
  // }, []);

  const options = {
    streetViewControl: false,
    zoom: 7,
    zoomControlOptions: {
      position: (window as any).google?.maps.ControlPosition.LEFT_BOTTOM, // 'right-center' ,
      style: (window as any).google?.maps.ZoomControlStyle.SMALL,
    },
    mapTypeId: 'roadmap', // maps.MapTypeId.HYBRID, // ROADMAP / SATELLITE / HYBRID / TERRAIN
    // heading: 207,
    // mapId: 'f494e4a36e8f86da',
    // styles,
  };

  if (!isLoaded) {
    return null;
  }

  const onMarkerClick = (event, markerData) => {
    setImageData(markerData);
  };

  const onImageClose = (event: React.SyntheticEvent) => {
    event.preventDefault();
    event.stopPropagation();

    setImageData(null);
  };

  const noteLabel: string = getText(mapData?.content, 'note', lng);
  const loadingLabel: string = getText(mapData?.content, 'loading', lng);
  const isImageVisible: boolean = Boolean(imageData);

  return (
    <div className={classes.containerStyle}>
      <div
        className={clsx(
          classes.wrapperStyle,
          isImageVisible && classes.hiddenStyle
        )}
      >
        <GoogleMap
          mapContainerStyle={containerStyle}
          center={mapCenter}
          // zoom={10}
          // onLoad={onLoad}
          options={options}
          // onUnmount={onUnmount}
        >
          {allAlbumData &&
            allAlbumData.map((marker, index) => {
              return (
                <Marker key={index} marker={marker} onClick={onMarkerClick} />
              );
            })}
        </GoogleMap>
        {!allAlbumData && (
          <div className={classes.mapDataLoadingStyle}>
            <CircularProgress color={'inherit'} />
            <div className={classes.mapLoadingTextStyle}>{loadingLabel}</div>
          </div>
        )}
      </div>
      {isImageVisible ? (
        <div className={classes.wrapperStyle}>
          <ImageStory
            sliderData={[imageData]}
            currentImageNr={1}
            onClose={onImageClose}
          />
        </div>
      ) : (
        <div className={classes.noteStyle}>{noteLabel}</div>
      )}
    </div>
  );
};

export default React.memo(AlbumMap);
